import React, { useEffect } from 'react'
import HeaderBar from '../../components/HeaderBar'
import { useLayoutEffect, useRef, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import MyOrders from './MyOrders'
import MySales from './MySales'

const tabList = [
    { name: 'Bestellungen', href: '#', current: true },
    { name: 'Verkäufe', href: '#', current: false },
  ]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const TabSwitcher = (props) => {

    switch (props.form) {
        case "Bestellungen":
          return <MyOrders/>
          break;
        case "Verkäufe":
          return <MySales/>
          break;
        default:
            return (<div>Default</div>)
            break;
    }

}
 
export default function Orders() {

    const [currentForm, setCurrentForm] = useState("Bestellungen")
    const [tabs, setNavigation] = useState(tabList)

    // const html = document.getElementsByTagName("html")[0];
    // useEffect(() => {
    //   html.classList.add("bg-gray-100")
    //   return () => {
    //     document.body.classList.remove('bg-gray-100');
    //   }
    // }, [])

    
    
    const switchMenu = (key) => {
        setCurrentForm(key)
        setNavigation(
            tabs.map((item) => {
              if (item.name === key) {
                return { ...item, current: true }
              } else {
                return { ...item, current: false};
              }
            })
          );
    }



  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });


  return (
    <>
    <HeaderBar title="Bestellungen" />
    <main className="flex-1">
              <div className="relative px-4 lg:px-0">                  
                  <div className="px-4 sm:px-6 md:px-0">
                      {/* Tabs */}
                     
                      <div className="lg:block">
                        <div className="border-b border-gray-200">
                          <nav className="-mb-px flex space-x-8">
                            {tabs.map((tab) => (
                              <a
                                key={tab._id}
                                href={tab.href}
                                onClick={()=>switchMenu(tab.name)}
                                className={classNames(
                                  tab.current
                                    ? 'border-purple-500 text-purple-600'
                                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                  'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                                )}
                              >
                                {tab.name}
                              </a>
                            ))}
                          </nav>
                        </div>
                      </div>
                      <div className="mt-10 divide-y divide-gray-200">
                        <div className="space-y-1">
                             <TabSwitcher form={currentForm}/>
                         </div>
                      </div>
                      
                  </div>
              </div>
            </main>
    </>

  )
}